import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay, faStop } from '@fortawesome/free-solid-svg-icons';

import { buttonShape } from './Header.shape';
import './Header.scss';

/**
 *
 * @param {*} props
 */
const Header = ({ title, status, buttons, eventEmitter }) => {
  /**
   * handle click event
   * @param {*} id
   */
  const handleClick = id => () => {
    eventEmitter({ id });
  };

  let icon = null;

  switch (status) {
    case 'pause':
      icon = faPause;
      break;
    case 'play':
      icon = faPlay;
      break;
    case 'stop':
      icon = faStop;
      break;
    default:
      break;
  }

  return (
    <div className="header-537d8329-70ee-4ba3-bb92-6ae760c2a516">
      <div className="grid-item left">
        <h1 className="md-title md-cell md-cell--12">{title}</h1>
        {icon && (
          <div className="icon-status">
            <FontAwesomeIcon icon={icon} size="sm" />
          </div>
        )}
      </div>
      {buttons.map(button => (
        <div className="grid-item right" key={`btn-${button.type}`}>
          <button
            className={cn(`button-${button.type}`, { button, disabled: button.disabled })}
            type="button"
            disabled={button.disabled}
            onClick={handleClick(button.id)}
          >
            {button.label}
          </button>
        </div>
      ))}
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.string,
  buttons: PropTypes.arrayOf(buttonShape),
  eventEmitter: PropTypes.func.isRequired,
};

Header.defaultProps = {
  status: '',
  buttons: [],
};

export default Header;
